import { StatusEnum } from '@common/constants';

export const USER_SPECIFIC_INITIAL_STATE = {
  status: StatusEnum.Uninitialized,
  data: null,
  userId: null,
};
